import { Box, Separator, Stack, Text } from '@chakra-ui/react'
import { Button, InputDate, InputSearch, Select } from 'uikit'
import { FilterFooter, FilterStack, FilterStackGroup } from 'uikit/layout'
import { ExportExcel } from '../ExportExcel/ExportExcel'
import { paymentFilterOptions, paymentTypeOptions } from '../Payments.constants'
import { InputCardSearch } from './blocks/InputCardSearch/InputCardSearch'

export const PaymentsFilter = ({
  totalItems,
  value = {},
  onChange,
  onReset,
  stats,
  statsIsLoading,
  onUpdateStats,
}) => {
  const handleFilter = (field) => {
    const fieldName = Object.keys(field)[0]
    const filedValue = field[fieldName]

    onChange({ ...value, [fieldName]: filedValue || undefined })
  }

  const handleResetFilter = () => {
    onChange({})
    onReset && onReset()
  }

  return (
    <>
      <FilterStack>
        <InputSearch
          hideIcon
          label="ФИО получателя"
          name="payeeFIO"
          value={value.payeeFIO}
          onChange={(e) => handleFilter({ payeeFIO: e })}
        />
        <InputCardSearch
          hideIcon
          label="Номер карточки получателя"
          name="payeeCardNumber"
          value={value.payeeCardNumber}
          onChange={(e) => handleFilter({ payeeCardNumber: e })}
        />
        <InputSearch
          hideIcon
          label="Телефон получателя"
          name="payeePhone"
          value={value.payeePhone}
          onChange={(e) => handleFilter({ payeePhone: e })}
        />
        <InputSearch
          hideIcon
          label="Телефон отправителя"
          name="payerPhone"
          value={value.payerPhone}
          onChange={(e) => handleFilter({ payerPhone: e })}
        />
        <InputSearch
          hideIcon
          label="Макс. сумма платежа"
          name="paymentAmountMax"
          value={value.paymentAmountMax}
          onChange={(e) => handleFilter({ paymentAmountMax: e })}
        />
        <InputSearch
          hideIcon
          label="Мин. сумма платежа"
          name="paymentAmountMin"
          value={value.paymentAmountMin}
          onChange={(e) => handleFilter({ paymentAmountMin: e })}
        />
        <InputSearch
          hideIcon
          label="Payment ID"
          name="paymentId"
          value={value.paymentId}
          onChange={(e) => handleFilter({ paymentId: e })}
        />
        <InputSearch
          hideIcon
          label="RRN"
          name="rrn"
          value={value.rrn}
          onChange={(e) => handleFilter({ rrn: e })}
        />
        <Select
          name="paymentType"
          label="Тип платежа"
          isSearchable={false}
          placeholder="Выберите"
          value={value.paymentType}
          options={[
            {
              value: '',
              label: 'Все',
            },
            ...paymentTypeOptions,
          ]}
          onChange={(e) => handleFilter({ paymentType: e.value })}
        />
        <Select
          name="paymentState"
          label="Статус"
          isSearchable={false}
          placeholder="Выберите"
          value={value.paymentState}
          options={[
            {
              value: '',
              label: 'Все',
            },
            ...paymentFilterOptions,
          ]}
          onChange={(e) => handleFilter({ paymentState: e.value })}
        />
        <FilterStackGroup>
          <InputDate
            value={value.paymentDateFrom}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="paymentDateFrom"
            placement="bottom"
            onChange={(e) => handleFilter({ paymentDateFrom: e })}
            label="Дата платежа"
            placeholder="C"
          />
          <InputDate
            value={value.paymentDateTo}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="paymentDateTo"
            placement="bottom"
            onChange={(e) => handleFilter({ paymentDateTo: e })}
            placeholder="По"
          />
        </FilterStackGroup>
      </FilterStack>
      <FilterFooter pb="10px">
        <Stack gap={2} width="100%" mb="20px">
          <ExportExcel size={totalItems} filter={value} />
          <Box>
            <Button size="sm" width="100%" onClick={handleResetFilter}>
              Очистить фильтр
            </Button>
            <Text
              fontSize="0.8rem"
              color="gray.300"
              mt={2}
              textAlign="center"
            >{`Найдено: ${totalItems}`}</Text>
          </Box>
        </Stack>
        <Separator />
        <Box width="full" mb="20px">
          <Text fontSize="18px" mt={2}>
            Статистика
          </Text>
          <Box>
            <Text fontSize="13px">{`Платежей найдено: ${
              stats?.numberOfPaymentsFound ?? ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма платежей: ${
              stats?.paymentsTotalRub ? stats?.paymentsTotalRub + ' руб' : ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма комиссий: ${
              stats?.commissionsTotalRub ? stats?.commissionsTotalRub + ' руб' : ' - '
            }`}</Text>
            <Text fontSize="13px">{`Сумма платежей c учетом комиссий: ${
              stats?.paymentsAndCommissionsTotalRub
                ? stats?.paymentsAndCommissionsTotalRub + ' руб'
                : ' - '
            }`}</Text>
          </Box>
          <Button loading={statsIsLoading} mt="15px" size="sm" width="100%" onClick={onUpdateStats}>
            {!stats ? 'Получить' : 'Обновить'}
          </Button>
        </Box>
      </FilterFooter>
    </>
  )
}
